import styled from 'styled-components'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'

export const MembershipAlert = styled.div`
  background: ${({ expired }) => (expired ? '#dd0d42' : '#0d3578')};
  padding: 0.5rem 1rem;
  color: #fff;
  text-align: center;
  border-radius: 0.25rem 0.25rem 0 0;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.43;
  cursor: pointer;
  box-shadow: 0 0.25rem #1454b8;
`

export const ConfirmationEmailHolder = styled.div`
  text-align: center;
  .image {
    margin: 1.5rem 0 0.5rem;
  }
`

export const PhysicalCardSection = styled.div`
  text-align: center;
`

export const RenewWrapper = styled.div`
  margin-bottom: 1rem;
`

export const RenewButton = styled(ButtonContained)`
  background-color: #cc5500;

  &:hover,
  &:active {
    background-color: #b34a00;
  }
`
